Vue.component('asset-favorite', {
    props: ['assetId', 'favorite'],
    //language=HTML
    template: `
        <div class="text-center">
            <a href="#" @click.prevent="toggleFavorite" class="favorite-toggle" :class="{favorite: isFavorite}"
               :data-test="'asset-favorite-' + assetId"
               :key="loadComponent">
                <span v-show="isFavorite">
                    <i class="fa fa-star text-danger"></i>
                </span>
                <span v-show="!isFavorite">
                    <i class="fal fa-star"></i>
                </span>
            </a>
        </div>
    `,
    data() {
        return {
            isFavorite: this.favorite,
        };
    },
    methods: {
        isAdvertiser() {
            return Spark && Spark.state && Spark.state.currentTeam && Spark.state.currentTeam.team_type === 1;
        },
        toggleFavorite() {
            const _this = this;

            if (this.isAdvertiser()) {
                axios.post('/api/favorites/toggle', {
                    model_name: 'App\\Modules\\Assets\\Models\\Asset',
                    model_id: this.assetId
                }).then((response) => {
                    _this.isFavorite = response.data.is_favorite;
                    _this.$noty.success(response.data.is_favorite ? 'Added favorite' : 'Removed favorite');
                    Bus.$emit('assetFavoriteToggle');
                    Bus.$emit('favoriteToggled', _this.assetId, response.data.is_favorite);
                });
            } else {
                axios.post('/api/team/assets/' + this.assetId + '/favorite').then((response) => {
                    const data = _this.$vueData.getData(response);
                    if (data.favorite) {
                        _this.isFavorite = true;
                        _this.$noty.success('Added favorite');
                    } else {
                        _this.isFavorite = false;
                        _this.$noty.success('Removed favorite');
                    }

                    Bus.$emit('assetFavoriteToggle');
                });
            }
        },
    },
    computed: {
        theIcon: function() {
            return [this.isFavorite ? 'fa' : 'fal', 'star'];
        },
    },
    watch: {
        assetId: function() {
            this.isFavorite = this.favorite;
        },
        favorite: function(val) {
            this.isFavorite = val;
        },
    },
});
